'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { sdkApi } from '../api.js';

const getOnrampProviders = (_a) => __awaiter(void 0, [_a], void 0, function* ({ chain, environmentId, networkId, token, walletAddress, }) {
    const { onramps } = yield sdkApi().getSupportedOnramps({
        chain,
        environmentId,
        networkId: networkId ? String(networkId) : undefined,
        token,
        walletAddress,
    });
    if (!onramps || onramps.length === 0) {
        throw new Error('No onramps');
    }
    return onramps;
});

export { getOnrampProviders };
